import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { SeoProperties } from '../../../types/GlobalTypes';
import { isDevelopment, isStage } from '../../../utils';
const defaultDescriptions = {
  en: 'Welcome to ZEP, the Metaverse for Everyone',
  ja: 'みんなのメタバース',
  ko: '모두를 위한 메타버스 ZEP으로 초대합니다!'
};
const Meta = (props: MetaProps) => {
  const {
    partialSeoContent
  } = props;
  const {
    locale,
    locales,
    asPath
  } = useRouter();
  const defaultDescription =
  // @ts-ignore
  defaultDescriptions[locale] ?? defaultDescriptions['ko'];
  const seoContent = {
    title: partialSeoContent?.title ?? 'ZEP',
    subject: partialSeoContent?.subject ?? '',
    description: partialSeoContent?.description ?? defaultDescription ?? '모두를 위한 메타버스 ZEP으로 초대합니다!',
    image: partialSeoContent?.image ?? 'https://zep.us/images/thumbnail.png?ver=22.10.3',
    keywords: partialSeoContent?.keywords ?? 'ZEP, metaverse, zepeto, meta, meta commerce, avatar, map, space, virtual world, game, zep script, creator',
    copyright: partialSeoContent?.copyright ?? 'ZEP Inc',
    author: partialSeoContent?.author ?? '',
    schema: partialSeoContent?.schema ?? {}
  };
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="Meta.tsx">
        <title>{seoContent.title}</title>
        <meta charSet="UTF-8" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="google-signin-client_id" content="193885560050-841lokv1235nmutetrie7p2mdof8k1kp.apps.googleusercontent.com" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="naver-site-verification" content="4dcf5ebf7b8c40900070239aa6b08ffca05509f8" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        {process.env.NEXT_PUBLIC_STAGE === 'PRD' && <meta name="google-adsense-account" content={process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_CLIENT_ID ?? ''} />}
        <meta name="viewport" content="width=device-width" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="description" content={seoContent.description} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="subject" content={seoContent.subject} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="keywords" content={seoContent.keywords} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:type" content="website" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:site_name" content={seoContent.title} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:url" content={process.env.NEXT_PUBLIC_BASE_URL} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:title" content={seoContent.subject || seoContent.title} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:description" content={seoContent.description} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:image" content={seoContent.image} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="og:locale" content={locale} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="twitter:card" content="summary" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="twitter:title" content={seoContent.title} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="twitter:description" content={seoContent.description} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta property="twitter:image" content={seoContent.image} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="application-name" content="ZEP" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="copyright" content={seoContent.copyright} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="author" content={seoContent.author} data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <meta name="reply-to" content="hello@zep.us" data-sentry-element="meta" data-sentry-source-file="Meta.tsx" />
        <link rel="icon" href="/favicon.ico" />
        {
      // @ts-ignore
      locales.filter(lang => locale !== lang).map(lang => <link key={lang} rel="alternate" hrefLang={lang} href={`${process.env.NEXT_PUBLIC_BASE_URL}/${lang}${asPath}`} />)}
        {isDevelopment || isStage ? <>
            <meta name="robots" content="noindex" />
            <meta name="googlebot" content="noindex" />
          </> : <meta name="robots" content="index, follow" />}
        {seoContent.schema['@context'] && <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify(seoContent.schema)
      }} />}
      </Head>
    </>;
};
export default Meta;
export interface MetaProps {
  partialSeoContent?: Partial<SeoProperties>;
}